function canRunCoverage(config) {
  const { logger, forceCalculation } = config;
  logger.log("check if we can run coverage");
  if (forceCalculation) {
    logger.warn("forceCalculation is enabled, some checks will be ignored");
  }
  if (!("requestIdleCallback" in globalThis)) {
    logger.error("no requestIdleCallback");
    return false;
  }
  const width = globalThis.document.documentElement.clientWidth;
  const height = globalThis.document.documentElement.clientHeight;
  if (width < 1280 || height < 800) {
    if (!forceCalculation) {
      logger.error("window too small");
      return false;
    }
  }
  return true;
}
export {
  canRunCoverage
};
//# sourceMappingURL=canRunCoverage.js.map
